import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-status"]

import { computed } from "vue";
  import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';
  import { TabStatus } from "@/types/tabs";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TabStatusIcon',
  props: {
    status: {}
  },
  setup(__props: any) {

  const props = __props;

  const hasExclamationStatus = computed(() => props.status == TabStatus.Exclamation);
  

return (_ctx: any,_cache: any) => {
  return (hasExclamationStatus.value)
    ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
        key: 0,
        class: "error-icon"
      }))
    : (__props.status)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: "icon-ok-circle",
          "data-status": __props.status
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
}
}

})